import { Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { AlertBox } from 'components/Box'

export const PrebidSettingsStaticAlert = (): React.JSX.Element => {
  const { t } = useTranslation('features/adUnit', {
    keyPrefix: 'form.unfilledRecovery.prebidSettings',
  })

  return (
    <AlertBox severity='warning'>
      <Typography sx={{ fontSize: 'inherit' }}>{t('staticAlert.title')}</Typography>
    </AlertBox>
  )
}
